import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  authUser: ["payload"],
  authUserLoading: null,
  authUserSuccess: ["authUserData"],
  authUserFailure: ["authUserError"],

  nuevaSesion: ["payload"],
  nuevaSesionLoading: null,
  nuevaSesionSuccess: ["nuevaSesionData"],
  nuevaSesionFailure: ["nuevaSesionError"],

  logoutUser: ["payload"],
  logoutUserSuccess: ["logoutUserData"],
  logoutUserLoading: null,
  logoutUserFailure: ["logoutUserError"],

  clearSesion: ["payload"],
  clearSesionSuccess: ["clearSesionData"],

  clearLogin: ["payload"],
  clearLoginSuccess: ["clearLoginData"],
});

export { Types };
export default Creators;